import { useState, useRef, useEffect } from "react";

import {
  Box,
  Drawer,
  Stack,
  Divider,
  Typography,
  IconButton,
  Button,
  Chip,
  CircularProgress,
  TextField,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import BadgeIcon from "@mui/icons-material/Badge";
import CloudDoneIcon from "@mui/icons-material/CloudDone";

import useHrmEmployeeStore from "../../../../../stores/hrEmployee";

const tipoContaOptions = [
  { label: "Não informada", value: 1 },
  { label: "Conta corrente", value: 2 },
  { label: "Conta salário", value: 3 },
  { label: "Conta poupança", value: 4 },
];

const formaPagamentoPeriodicidadeOptions = [
  { label: "Por mês", value: 1 },
  { label: "Por semana", value: 2 },
];

const HRManagementEmployeeProfessional = () => {
  const [state, setState] = useState(false);
  const openRef = useRef(null);
  const saveDraft = useHrmEmployeeStore((state: any) => state.saveDraft);
  const changeDraft = useHrmEmployeeStore((state: any) => state.changeDraft);
  const isSaving = useHrmEmployeeStore((state: any) => state.isSaving);
  const data = useHrmEmployeeStore((state: any) => state.data);
  const addDrawersRef = useHrmEmployeeStore(
    (state: any) => state.addDrawersRef,
  );

  useEffect(() => addDrawersRef({ name: "professional", ref: openRef }), []);

  return (
    <>
      <Button
        fullWidth
        ref={openRef}
        variant="outlined"
        onClick={() => setState(true)}
        disabled={data?.status !== "editing"}
      >
        <Stack spacing={1} alignItems="center">
          <BadgeIcon fontSize="large" />
          <div>Profissional</div>
        </Stack>
      </Button>
      <Drawer anchor="left" open={state} onClose={() => setState(false)}>
        <Box sx={{ p: 3, pt: 2, width: 400 }} height="100%">
          <Stack height="100%" spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" sx={{ flex: 1 }}>
                Profissional
              </Typography>
              {data.status === "editing" && (
                <Chip
                  color="success"
                  variant="outlined"
                  icon={
                    isSaving ? (
                      <CircularProgress color="warning" size={18} />
                    ) : (
                      <CloudDoneIcon fontSize="small" />
                    )
                  }
                  label={isSaving ? "Salvando..." : "Tudo Salvo"}
                />
              )}
              <IconButton onClick={() => setState(false)}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Divider />
            <TextField
              name="pagamento_banco"
              fullWidth
              variant="filled"
              label="Banco"
              value={data.draft?.pagamento_banco ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            />
            <TextField
              name="forma_pagamento"
              fullWidth
              variant="filled"
              select
              label="Meio de pagamento"
              value={data.draft?.forma_pagamento ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              required
            >
              <option value=""></option>
              <option value="C">Crédito em conta</option>
              <option value="D">Dinheiro</option>
              <option value="H">Cheque</option>
            </TextField>
            <TextField
              name="pagamento_banco_conta"
              fullWidth
              variant="filled"
              label="Número da Conta"
              value={data.draft?.pagamento_banco_conta ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            />
            <TextField
              name="pagamento_banco_conta_digito"
              fullWidth
              variant="filled"
              label="Dígito da Conta"
              value={data.draft?.pagamento_banco_conta_digito ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            />
            <TextField
              name="pagamento_tipo_conta"
              fullWidth
              variant="filled"
              select
              label="Tipo da Conta"
              value={data.draft?.pagamento_tipo_conta ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              required
            >
              <option value=""></option>
              {tipoContaOptions.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </TextField>
            <TextField
              name="forma_calculo"
              fullWidth
              variant="filled"
              select
              label="Forma de pagamento"
              value={data.draft?.forma_calculo ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            >
              <option value=""></option>
              {formaPagamentoPeriodicidadeOptions.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </TextField>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default HRManagementEmployeeProfessional;
